<script lang="ts">
	// PROPS
	export let width: number = 24;
	export let height: number = 24;
	export let url: string = '#a';
	export let variant: 'light' | 'dark' = 'light';
</script>

<a
	class="platform-link {variant}"
	href="{url}"
	target="_blank"
	rel="noreferrer"
>
	<svg xmlns="http://www.w3.org/2000/svg" {width} {height} viewBox="0 0 24 24"
		><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
		></path></svg
	>
</a>

<style lang="scss">
	@use '$styles/colors' as *;

	a {
		display: inline-block;
		border-radius: 50%;
		background: $rfe-gray-3;
		padding: 0.5rem;

		&:hover {
			background: var(--brand-primary);
		}
	}

	a.light {
		background: $rfe-gray-5;

		svg {
			fill: white;
		}

		&:hover {
			background: var(--brand-primary);
		}
	}

	a.dark {
		background: white;

		svg {
			fill: $rfe-gray-5;
		}

		&:hover {
			background: $rfe-gray-5;

			svg {
				fill: white;
			}
		}
	}

	svg {
		display: block;
		margin: 0 auto;
	}
</style>
